// Imort Core
import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
// Import Components
import RelatedTripsLocations from "../RelatedTripsLocations";
// Import Utils
import { usePlaceholderImage } from "../../../utils/useRandomPlaceholderImage";
import { getShortDate } from "../../../utils/datetime/getShortDate";
import { Link } from "gatsby";

const SingleProductHeroStyling = styled.div`
  display: flex;
  align-items: center;
  height: 500px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    height: unset;
  }
  .hero-content {
    display: flex;
    /* width: 738px; */
    max-width: 738px;
    height: 100%;
    padding: 80px 80px 40px 64px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    @media (max-width: 1100px) {
      width: 60%;
    }
    @media (max-width: 992px) {
      width: 50%;
    }
    @media (max-width: 768px) {
      width: 100%;
      padding: 40px 20px 24px 20px;
      gap: 40px;
    }
    .heading {
      display: flex;
      flex-direction: column;
      gap: 16px;
      .tagline {
        color: var(--grey);
      }
      .title {
        color: var(--red);
      }
      .subheading {
        color: var(--neutral-75);
        text-transform: uppercase;
        font-family: var(--font-family-heading);
      }
      .departures {
        color: var(--neutral-75);
        text-transform: capitalize;
      }
      .price {
        color: var(--blue);
      }
    }
  }
  .hero-image {
    position: relative;
    flex: 1 0 0;
    height: inherit;
    @media (max-width: 1100px) {
      width: 40%;
      flex: unset;
    }
    @media (max-width: 992px) {
      width: 50%;
    }
    @media (max-width: 768px) {
      width: 100%;
      height: 250px;
    }
    .gatsby-image-wrapper,
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      max-height: inherit;
    }
    .placeholder-img {
      object-fit: contain;
    }
    .caption-title {
      position: absolute;
      right: 20px;
      bottom: 12px;
      font-family: var(--font-family-base);
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      color: var(--white);
      text-align: center;
      z-index: 2;
      text-shadow: 1px 1px 20px #000, 0 0 1em #000, 0 0 0.2em #000;
    }
  }
`;

const SingleProductHero = ({
  pageType,
  title,
  tagline,
  subheading,
  image,
  departures,
  price,
  duration,
  caption,
}) => {
  const { randomPlaceholderImage } = usePlaceholderImage();
  return (
    <SingleProductHeroStyling>
      <div className="hero-content">
        <div className="heading">
          <p className="tagline">{tagline}</p>
          <h2 className="title">{title}</h2>
          {subheading && pageType !== "event" && (
            <h5 className="subheading">{subheading}</h5>
          )}
          {departures && (
            <p className="departures medium bold">
              {" "}
              {pageType === "event" ? "Date" : "Departs"}: {departures}
            </p>
          )}
          {pageType === "event" ? (
            <p className="price medium bold">Price: £{price} per person</p>
          ) : price === "Price on Request" ? (
            <p className="price medium bold">
              From {duration} nights. Prices on Request
            </p>
          ) : duration && price && price !== "NaN" ? (
            <p className="price medium bold">
              {duration} nights from £{price} per person
            </p>
          ) : !duration && price && price !== "NaN" ? (
            <p className="price medium bold">{price}</p>
          ) : (
            pageType === "culturalTour" && (
              <p className="price medium bold">
                Next departure to be confirmed
              </p>
            )
          )}
        </div>
      </div>
      <div className="hero-image">
        {image ? (
          <GatsbyImage image={getImage(image)} alt="Kirker Holidays" />
        ) : (
          <img
            src={randomPlaceholderImage}
            alt=""
            className="placeholder-img"
          />
        )}
        {caption && pageType !== "event" && (
          <p className="caption-title">{caption}</p>
        )}
      </div>
    </SingleProductHeroStyling>
  );
};

export default SingleProductHero;
